import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavItem } from './nav-item.interface';

@Component({
  selector: 'util-recursive-dropdown-menu',
  template: `<mat-menu #childMenu="matMenu" [overlapTrigger]="false">
  <span *ngFor="let item of items">
    <span *ngIf="item.children && item.children.length > 0">
      <button mat-menu-item [matMenuTriggerFor]="menu.childMenu">
        <!-- <span *ngIf="item.icon" [ngClass]="item.icon"></span> -->
        <span>{{item.label}}</span>
      </button>
      <util-recursive-dropdown-menu #menu [items]="item.children"></util-recursive-dropdown-menu>
    </span>
    <span *ngIf="!item.children || !item.children.length > 0">
      <button mat-menu-item (click)="item.action()">
        <!-- <span *ngIf="item.icon" [ngClass]="item.icon"></span> -->
        <span>{{item.label}}</span>
      </button>
    </span>
  </span>
</mat-menu>
  `,
  styles: [``]
})
export class RecursiveDropdownMenuComponent {
  @Input() items: NavItem[];
  @ViewChild('childMenu') public childMenu;
}
